<template>
  <div class="container py-4">
    
    <div class="modal fade" id="modalError" tabindex="-1" role="dialog" aria-labelledby="modalErrorTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorTitle">Ooops...</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            An error occurred, please try again later.
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <pno-loading :loading="loading">
    
    <br class="d-none d-sm-block">
    <div class="row">
      <div class="col-lg-3">
        <h1 class="h4 mb-1">Get started</h1>
        <p class="grey">Fill out your information and we'll reach out to get you on-board.</p>
        <hr>
      </div>
      <div class="col-lg-7 offset-lg-1">
        <form @submit="submit" novalidate>
          <p class="small grey text-uppercase mb-3">Contact details</p>
          <div class="form-row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Full name</label>
                <input class="form-control" type="text" :class="errors.fullName ? 'is-invalid' : ''" required v-model="requestForm.fullName">
                <div class="invalid-feedback">
                  Please enter your name
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Title</label>
                <input class="form-control" type="text" :class="errors.title ? 'is-invalid' : ''" required v-model="requestForm.title">
                <div class="invalid-feedback">
                  Please enter your title
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Email</label>
                <input class="form-control" type="email" :class="errors.email ? 'is-invalid' : ''" required v-model="requestForm.email">
                <div class="invalid-feedback">
                  Please enter a valid email
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Phone</label>
                <input class="form-control" type="tel" :class="errors.phone ? 'is-invalid' : ''" required v-model="requestForm.phone">
                <div class="invalid-feedback">
                  Please enter your phone number
                </div>
              </div>
            </div>
          </div>
          <p class="small grey text-uppercase mb-3">Company details</p>
          <div class="form-row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Company name</label>
                <input class="form-control" :class="errors.companyName ? 'is-invalid' : ''" type="text" required v-model="requestForm.companyName">
                <div class="invalid-feedback">
                  Please enter a company name
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Country</label>
                <input class="form-control" :class="errors.country ? 'is-invalid' : ''" type="text" required v-model="requestForm.country">
                <div class="invalid-feedback">
                  Please enter a country
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Fleet size - <span class="grey">Curtain</span></label>
                <select class="form-control" :class="errors.fleetSizeCurtain ? 'is-invalid' : ''" required v-model="requestForm.fleetSizeCurtain">
                  <option></option>
                  <option value="1-34">1-34 curtain trailers</option>
                  <option value="35-74">35-74 curtain trailers</option>
                  <option value="75-149">75-149 curtain trailers</option>
                  <option value="+150">+150 curtain trailers</option>
                </select>
                <div class="invalid-feedback">
                  Please select a fleet size
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="small">Fleet size - <span class="grey">Other</span></label>
                <select class="form-control" :class="errors.fleetSizeOther ? 'is-invalid' : ''" required v-model="requestForm.fleetSizeOther">
                  <option></option>
                  <option value="1-24">1-24 other trailers</option>
                  <option value="25-49">25-49 other trailers</option>
                  <option value="50-99">50-99 other trailers</option>
                  <option value="100+">100+ other trailers</option>
                </select>
                <div class="invalid-feedback">
                  Please select a fleet size
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mt-1">
            <button type="submit" class="btn btn-lg btn-success btn-block mb-3">Send information</button>
            <small class="form-text grey">By submitting, you agree to our <a href="http://pnorental.com/wp-content/uploads/2018/07/Privacy-Policy.pdf" target="_blank" rel="nofollow" class="dark">Privacy Policy</a>.</small>
          </div>
        </form>
      </div>
    </div>
    </pno-loading>
    <br>
  </div>
</template>

<script>
  export default {
    mounted() {
      this.$store.commit('meta/title', 'Get started')
    },
    data: () => ({
      requestForm: {},
      loading: false,
      errors: {},
    }),
    methods: {
      validEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      validateForm() {
        const errors = {}
        if (!this.requestForm.companyName) errors.companyName = true
        if (!this.requestForm.country) errors.country = true
        if (!this.requestForm.fleetSizeCurtain) errors.fleetSizeCurtain = true
        if (!this.requestForm.fleetSizeOther) errors.fleetSizeOther = true
        if (!this.requestForm.fullName) errors.fullName = true
        if (!this.requestForm.title) errors.title = true
        if (!this.requestForm.email) errors.email = true
        if (!this.requestForm.phone) errors.phone = true
        if (!this.validEmail(this.requestForm.email)) errors.email = true
        return errors
      },
      submit(e) {
        e.preventDefault()
        this.errors = this.validateForm()
        if (Object.keys(this.errors).length > 0) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return
        }
        this.requestListing()
      },
      async requestListing() {
        try {
          this.loading = true
          await this.$store.dispatch('quote/requestListing', this.requestForm)
          this.loading = false
          this.$nextTick(() => this.$router.push('/thanks'))
        }
        catch (error) {
          this.loading = false
          $('#modalError').modal('show')
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      }
    }
  }
</script>
